import request from '../../utils/requests'

/**
 * Tag: OrgUser
 */

const baseUrl ="/api/orguser";



/**
 * 新增
 * @param {*} body
 * {
 *    OrgUserId Desc:主键 Required:false
 *    Name Desc:姓名 Required:true
 *    ImgUrl Desc:照片 Required:false
 *    Phone Desc:手机号 Required:true
 *    Account Desc:账户 Required:false
 *    Password Desc:密码 Required:false
 *    IDCard Desc:身份证 Required:false
 *    Sex Desc:性别 0 未知 1男 2女 Required:false
 *    OrgUserState Desc:状态(目前备用) Required:false
 *    IsSeller Desc:是否是销售者 Required:false
 *    IsTeacher Desc:是否是老师 Required:false
 *    SuperiorLeadership Desc:上级领导 Required:false
 *    IsQuit Desc:是否离职 Required:false
 *    Remark Desc:备注 Required:false
 *    BranchIdList Desc:校区IDList Required:false
 *    RoleIdList Desc:权限IDList Required:false
 *    TrainTypeIdList Desc:培训类型IDList Required:false
 *    OrgId Desc:机构ID(后台使用) Required:false
 * }
 */
async function _add(body) {
  return request(baseUrl+'/add',{
    method: 'POST',
    body: body,
  });

}



/**
 * 更新
 * @param {*} body
 * {
 *    OrgUserId Desc:主键 Required:false
 *    Name Desc:姓名 Required:true
 *    ImgUrl Desc:照片 Required:false
 *    Phone Desc:手机号 Required:true
 *    Account Desc:账户 Required:false
 *    Password Desc:密码 Required:false
 *    IDCard Desc:身份证 Required:false
 *    Sex Desc:性别 0 未知 1男 2女 Required:false
 *    OrgUserState Desc:状态(目前备用) Required:false
 *    IsSeller Desc:是否是销售者 Required:false
 *    IsTeacher Desc:是否是老师 Required:false
 *    SuperiorLeadership Desc:上级领导 Required:false
 *    IsQuit Desc:是否离职 Required:false
 *    Remark Desc:备注 Required:false
 *    BranchIdList Desc:校区IDList Required:false
 *    RoleIdList Desc:权限IDList Required:false
 *    TrainTypeIdList Desc:培训类型IDList Required:false
 *    OrgId Desc:机构ID(后台使用) Required:false
 * }
 */
async function _update(body) {
  return request(baseUrl+'/update',{
    method: 'POST',
    body: body,
  });

}



/**
 * 删除
 * @param {*} param
 * {
 *    orgUserId Desc: Required:true
 * }
 */
async function _deleteBranchUser(param) {
  return request(baseUrl+'/DeleteBranchUser',{
    method: 'GET',
    params: param,
  });

}

/**
 * 删除
 * @param {*} param
 * {
 *    orgUserId Desc: Required:true
 * }
 */
async function _delete(param) {
  return request(baseUrl+'/delete',{
    method: 'GET',
    params: param,
  });

}



/**
 * 设置离职状态
 * @param {*} param
 * {
 *    orgUserId Desc: Required:true
 *    isQuit Desc:0：在职,1：离职 Required:true
 * }
 */
async function _setIsQuit(param) {
  return request(baseUrl+'/setIsQuit',{
    method: 'GET',
    params: param,
  });

}



/**
 * 设置是否显示新用户指南
 * @param {*} param
 * {
 *    orgUserId Desc: Required:true
 *    IsShowUserGuide Desc:是否显示新用户指南 Required:true
 * }
 */
async function _setUserGuide(param) {
  return request(baseUrl+'/setUserGuide',{
    method: 'GET',
    params: param,
  });

}



/**
 * 修改密码
 * @param {*} body
 * {
 *    OrgUserId Desc:用户ID Required:true
 *    OldPassword Desc:原始密码 Required:true
 *    NewPassword Desc:新密码密码 Required:true
 *    ValidPassword Desc:新密码验证 Required:true
 * }
 */
async function _changePassword(body) {
  return request(baseUrl+'/changePassword',{
    method: 'POST',
    body: body,
  });

}



/**
 * 员工Model
 * @param {*} body
 * {
 *    OrgUserId Desc:主键 Required:false
 *    BranchId Desc:校区ID Required:false
 *    Name Desc:员工姓名 Required:false
 *    Phone Desc:员工手机号 Required:false
 *    OrgId Desc:机构ID(后台使用) Required:false
 * }
 */
async function _getModel(body) {
  return request(baseUrl+'/getModel',{
    method: 'POST',
    body: body,
  });

}



/**
 * 员工列表分页
 * @param {*} body
 * {
 *    NameOrPhone Desc:姓名/手机号 Required:false
 *    BranchId Desc:校区ID Required:false
 *    IsQuit Desc:是否离职(-1：全部，0：在职，1：离职) Required:false
 *    OrgId Desc:机构ID(后台使用) Required:false
 *    OrgUserId Desc:员工IDList Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _paging(body) {
  return request(baseUrl+'/paging',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取用户下属员工
 * @param {*} param
 * {
 *    userid Desc: Required:true
 * }
 */
async function _getSubordinate(param) {
  return request(baseUrl+'/getSubordinate',{
    method: 'GET',
    params: param,
  });

}



/**
 * 解除绑定
 * @param {*} param
 * {
 *    openid Desc: Required:true
 * }
 */
async function _unBindWechat(param) {
  return request(baseUrl+'/unBindWechat',{
    method: 'GET',
    params: param,
  });

}



/**
 * 绑定微信用户
 * @param {*} param
 * {
 *    openid Desc: Required:true
 * }
 */
async function _bindWechat(param) {
  return request(baseUrl+'/bindWechat',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取通知开启状态
 * @param {*} param
 * {
 *    openid Desc: Required:true
 * }
 */
async function _getWxNoticeState(param) {
  return request(baseUrl+'/getWxNoticeState',{
    method: 'GET',
    params: param,
  });

}



/**
 * 更新管理员 手机号
 * @param {*} body
 * {
 *    OriginPhone Desc:原始手机 Required:false
 *    NewPhone Desc:新手机 Required:false
 *    OrgId Desc:机构Id Required:false
 * }
 */
async function _updateAdminPhone(body) {
  return request(baseUrl+'/updateAdminPhone',{
    method: 'POST',
    body: body,
  });

}



export default{
  _add,
  _update,
  _delete,
  _deleteBranchUser,
  _setIsQuit,
  _setUserGuide,
  _changePassword,
  _getModel,
  _paging,
  _getSubordinate,
  _unBindWechat,
  _bindWechat,
  _getWxNoticeState,
  _updateAdminPhone
}




// WEBPACK FOOTER //
// ./src/services/orguser.js